import { Dialog, styled } from '@mui/material';
import { forwardRef } from 'react';

import type { ChkModalProps } from './ChkModal.types';

export const ChkModal = forwardRef<HTMLDivElement, ChkModalProps>(
  ({ ...props }, ref) => {
    return <StyledDialog ref={ref} {...props} />;
  }
);

const StyledDialog = styled(Dialog)(({ theme, fullScreen }) => ({
  '.MuiPaper-root': {
    ...(!fullScreen && { borderRadius: theme.borders.borderRadius2 }),
  },
}));
